import { useAppStore } from "@/global/store";
import { selectUser } from "@/global/store/data/user";
import {
  Box,
  Divider,
  Link,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from "@mui/material";
import { AiOutlineDollarCircle } from "react-icons/ai";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import { TbShirtSport } from "react-icons/tb";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Click Get Started",
    description:
      "Click Get Started on your desktop, laptop, or mobile device to begin.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Connect your Pistons account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Games",
    description: "Select your games and seats.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description:
      "Tickets will be available in your Account Manager within 24 hours of redemption. Reach out to Live Fan Support for any questions.",
  },
];

export const faqs = [
  {
    title: "How does the Pistons Flex program work?",
    description:
      "The Pistons Flex program allows fans to select any seat to any game. Simply log into your Pistons Account manager and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description:
      "In order to purchase your Lager for the Lakes Plan you must buy a minimum of three games in one single purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description:
      "Event tickets are delivered directly within your Pistons Account Manager within an hour of selection.",
  },
  {
    title: "How does the Great Lakes donation work?",
    description: (
      <div>
        If you include one of the following opponents in your plan, $5 will be
        donated to keeping the Great Lakes clean courtesy of Bell&apos;s
        Brewing:
        <ul style={{ fontWeight: 600 }}>
          <li>Milwaukee Bucks: Jan. 20 @ 3 PM</li>
          <li>Milwaukee Bucks: Jan. 22 @ 7 PM</li>
          <li>Cleveland Cavaliers: Mar. 1 @ 7 PM</li>
          <li>Toronto Raptors: Mar. 13 @ 7 PM</li>
          <li>Chicago Bulls: Apr. 11 @ 7 PM</li>
        </ul>
      </div>
    ),
  },
];

export function CheckoutTerms() {
  return (
    <>
      By purchasing you agree to receive SMS alerts regarding ticket delivery
      and agree to the{" "}
      <Link
        // fontWeight={"bold"}
        // textDecor="underline"

        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/616882d2b691e09f75348396_Terms%20%26%20Conditions.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Terms & Conditions
      </Link>{" "}
      and{" "}
      <Link
        // fontWeight={"bold"}
        // textDecor="underline"
        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/63c05d80816dac05b5b34ac7_seasonshare%20CCPA%20Privacy%20Policy%20Agreement.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Privacy Policy
      </Link>
      .
    </>
  );
}

export function TopNavMenuItems() {
  const user = useAppStore(selectUser);

  return (
    <Box>
      {user ? <Divider /> : null}
      <MenuList>
        <MenuItem
          onClick={() => {
            window.open(
              "https://forms.pistons.com/forms/view/1074?tfa_267=SeasonShare",
              "_blank"
            );
          }}
        >
          <ListItemIcon>
            <OpenInNewRoundedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Speak To A Representative</ListItemText>
        </MenuItem>
      </MenuList>
    </Box>
  );
}
